export const CLINIC = 'clinic'
export const PATIENT = 'patient'
export const CAREGIVER = 'caregiver'
export const INFORMANT = 'informant'

export const roles = [CLINIC, PATIENT, CAREGIVER, INFORMANT]
